import { Dispatch } from "react";
import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction, AnyAction } from "@reduxjs/toolkit";
import { fetchCollectionFitrah } from "./api";
import type {
  CollectionFitrah,
  CollectionFitrahSummary,
  PaymentReport
} from "./api";

interface Report {
  data: CollectionFitrah[];
  stats: CollectionFitrahSummary;
}

export interface Collection {
  fitrah: Report;
}

const defaultFitrah = (): Report => {
  return {
    data: [],
    stats: {
      page: 0,
      items_per_page: 0,
      count: 0,
      total_pages: 0,
      paid_amount: 0,
      charges: 0,
      amount: 0,
      amil_amount: 0,
      body_amount: 0
    }
  };
};

const initialState: Collection = {
  fitrah: defaultFitrah()
};

const collectionStateSlice = createSlice({
  name: "collectionState",
  initialState,
  reducers: {
    setFitrah(state, action: PayloadAction<PaymentReport | null>) {
      const resp = action.payload;

      if (resp === null) {
        state.fitrah = defaultFitrah();
        return;
      }

      if (resp.status === "OK") {
        state.fitrah = {
          data: resp.data,
          stats: resp.stats
        };
      }
    }
  }
});

export const { setFitrah } = collectionStateSlice.actions;

export const updateCollectionFitrah = (
  token: string,
  form: { [key: string]: string }
) => async (dispatch: Dispatch<AnyAction>) => {
  try {
    dispatch(setFitrah(null));
    const data = await fetchCollectionFitrah(form)(token);
    dispatch(setFitrah(data));
  } catch (e) {
    console.log(e);
  }
};

export default collectionStateSlice.reducer;
